import { render, staticRenderFns } from "./DashboardCommentSection.vue?vue&type=template&id=ffb8ddc8&scoped=true"
import script from "./DashboardCommentSection.vue?vue&type=script&lang=js"
export * from "./DashboardCommentSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardCommentSection.vue?vue&type=style&index=0&id=ffb8ddc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb8ddc8",
  null
  
)

export default component.exports